import { render, staticRenderFns } from "./DashboardSelectPageTab.vue?vue&type=template&id=27e9d17e&scoped=true&"
import script from "./DashboardSelectPageTab.vue?vue&type=script&lang=ts&"
export * from "./DashboardSelectPageTab.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSelectPageTab.vue?vue&type=style&index=0&id=27e9d17e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e9d17e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
